import { Observable } from 'rxjs'
import { EnrollmentFieldBeneficiary, EnrollmentFieldCodesBeneficiary } from '../models/enrollment-field-beneficiary'
import { BeneficiaryInfoBeneficiary } from '../models/enrollments-beneficiary'
import { EappUpdateStatusBeneficiary } from '../models/eapp-beneficiary-status-model'
import { BeneficiaryElectionPeriods } from '../models/beneficiary-election-periods'
import { EnrollmentElectionType } from '../models/enrollment-election-type'
import { UserProfile } from '../models/user-profile'
import { EnrollmentViewModel } from '../models/enrollment-view-model'
import { PlanList } from '../models/plan-list'
import { SubmitEnrollmentDataResponse } from '../models/submit-enrollment-data-response'
import { ValidatedSelectOptionModel } from '../../validations/validated-dropdown.component'
import { VerifyBeneficiary } from '../models/verify-beneficiary'
import { GenderPref } from '../../enrollment/models/gender-pref'
import { RelationshipToEnrollee } from '../models/relationshipToEnrollee'

export abstract class EappBeneficiaryGateway {
    public _backClicked: boolean
    abstract getEnrollmentAppDetails(guid: string): Observable<EnrollmentFieldBeneficiary[]>
    abstract getEappDetails(uniqueLink: string): Observable<EappUpdateStatusBeneficiary[]>
    abstract updateEAppStatus(eappUpdateStatus: EappUpdateStatusBeneficiary): Observable<EappUpdateStatusBeneficiary>
    // abstract getEnrollmentSetting(planYear: string): Observable<EnrollmentSettingModel>
    abstract SendAgentEmail(mailTo: string, Reason: string, agentName: string, agentID: number, beneName: string): Observable<any>
    abstract findUserProfileByProfileID(profileID: number): Observable<UserProfile>
    abstract getElectionPeriods(orgId: number, planYear: string): Observable<BeneficiaryElectionPeriods[]>
    abstract getEnrollmentElectionTypes(orgID: string, planYear: string): Observable<EnrollmentElectionType[]>
    abstract getEnrollmentViewModel(): EnrollmentViewModel
    abstract setEnrollmentViewModel(value: EnrollmentViewModel)
    abstract getPlanList(orgId: number, planyear: string): Observable<PlanList[]>
    abstract UpdateElectronicEnrollmentData(submitEnrollmentData: EnrollmentViewModel): Observable<SubmitEnrollmentDataResponse>
    abstract SubmitEnrollmentData(submitEnrollmentData: EnrollmentViewModel): Observable<SubmitEnrollmentDataResponse>
    abstract SendEmailUser(): Observable<any>
    abstract SendEappEmailOnConfirmation(planName: string): Observable<any>
    abstract getLogoPath(orgId: number, planyear: string): Observable<string> | undefined
    abstract GetAllStatesForBeneficiary(InsuranceCoID: number): Observable<ValidatedSelectOptionModel[]>

    abstract notifyeAppAgent(agentId: number, bFName: string, bLName: string, reason: string): Observable<any>
    abstract verifyBeneficiary(beneficiaryInfo: VerifyBeneficiary): Observable<EappUpdateStatusBeneficiary>
    abstract GetGenderPreferenceListForBeneficiary(genderPref: string): Observable<GenderPref[]>

    //abstract getRelationshipToEnrolleeData(): Observable<RelationshipToEnrollee[]>
    abstract getRelationshipToEnrolleeDataForBeneficiary(): Observable<RelationshipToEnrollee[]>
}
